import { useMemo } from 'react';
import { isDevelopment, isProduction, getEnvironment } from './utils/env';

/**
 * React hook for accessing development mode status
 *
 * @returns Object containing environment helpers
 */
export function useDevMode() {
  return useMemo(() => ({
    isDev: isDevelopment(),
    isProd: isProduction(),
    environment: getEnvironment(),
  }), []);
}
